import { render, staticRenderFns } from "./ShipLoading.vue?vue&type=template&id=21d685df&scoped=true"
import script from "./ShipLoading.vue?vue&type=script&lang=js"
export * from "./ShipLoading.vue?vue&type=script&lang=js"
import style0 from "./ShipLoading.vue?vue&type=style&index=0&id=21d685df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d685df",
  null
  
)

export default component.exports